import React, { Suspense } from 'react';
import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import routes from './routes/Index';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Screenshot protection hook
// const useScreenshotProtection = () => {
//   const [isBlurred, setIsBlurred] = useState(false);

//   useEffect(() => {
//     // Detect when user switches tabs or minimizes window
//     const handleVisibilityChange = () => {
//       if (document.hidden) {
//         setIsBlurred(true);
//       } else {
//         setIsBlurred(false);
//       }
//     };

//     // Detect screenshot attempts
//     const handleKeyDown = (e:any) => {
//       if (
//         (e.ctrlKey && e.shiftKey && e.key === 'S') ||
//         (e.metaKey && e.shiftKey && e.key === '3') ||
//         (e.metaKey && e.shiftKey && e.key === '4') ||
//         (e.key === 'PrintScreen') ||
//         (e.altKey && e.key === 'PrintScreen')
//       ) {
//         e.preventDefault();
//         alert('Screenshots are not allowed on this application');
//         return false;
//       }
//     };

//     const handleContextMenu = (e:any) => {
//       e.preventDefault();
//       return false;
//     };

//     const handleSelectStart = (e:any) => {
//       e.preventDefault();
//       return false;
//     };

//     document.addEventListener('visibilitychange', handleVisibilityChange);
//     document.addEventListener('keydown', handleKeyDown);
//     document.addEventListener('contextmenu', handleContextMenu);
//     document.addEventListener('selectstart', handleSelectStart);

//     // Add protection styles
//     const style = document.createElement('style');
//     style.textContent = `
//       * {
//         -webkit-user-select: none;
//         -moz-user-select: none;
//         -ms-user-select: none;
//         user-select: none;
//         -webkit-touch-callout: none;
//         -webkit-tap-highlight-color: transparent;
//       }
      
//       @media print {
//         * { visibility: hidden !important; }
//         body::after {
//           content: "Printing is not allowed";
//           position: fixed;
//           top: 50%;
//           left: 50%;
//           transform: translate(-50%, -50%);
//           font-size: 24px;
//           visibility: visible !important;
//         }
//       }
      
//       img {
//         -webkit-user-drag: none;
//         user-drag: none;
//         pointer-events: none;
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//       document.removeEventListener('keydown', handleKeyDown);
//       document.removeEventListener('contextmenu', handleContextMenu);
//       document.removeEventListener('selectstart', handleSelectStart);
//       if (style.parentNode) {
//         document.head.removeChild(style);
//       }
//     };
//   }, []);

//   return isBlurred;
// };

function App() {
  // const isBlurred = useScreenshotProtection();

  return (
    <div className={`relative `}>
    {/* <div className={`relative ${isBlurred ? 'blur-lg' : ''}`}> */}
      {/* Watermark overlay */}
      {/* <div className="fixed inset-0 pointer-events-none z-40 opacity-10">
        <div 
          className="absolute inset-0 bg-repeat" 
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23041A3C' opacity='0.3' font-size='12' transform='rotate(-45 50 50)'%3EPROTECTED%3C/text%3E%3C/svg%3E")`,
            backgroundSize: '150px 150px'
          }}
        />
      </div> */}

      <Suspense fallback={
        <div className="flex justify-center items-center h-screen">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#041A3C]"></div>
        </div>
      }>
        <Routes>
          {routes.map(
            (route: any, i: number) =>
              route.component && (
                <Route key={i} path={route.path} element={<route.component />} />
              )
          )}
        </Routes>
      </Suspense>
           <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3}
      />
    </div>
  );
}

export default App;